import { MOVE_OUT_CONFIRM_METER_READ_SUBMIT } from '@/src/constants/analytics-subjects';
import { ROUTE_METER_READINGS } from '@/src/constants/routes';
import { Card, CTAButton, Heading2, Li, Stack, Ul } from '@ovotech/element-v4';
import { AnalyticsClick } from '@ovotech/ui-tools';
import React from 'react';
import { Step } from '../Step/Step';
import styles from './WhatsNextCard.module.css';

export const WhatsNextCard = ({ date }: { date: string }) => {
  return (
    <Card>
      <Heading2 className={styles.title}>What's next</Heading2>
      <Stack spaceBetween={[6, 10, 10]}>
        <Step iconText="1">
          <div className={styles.listTitle}>
            Final meter reading instructions
          </div>
          <Ul>
            <Li>
              If you have a smart meter, we'll take a reading automatically.
            </Li>
            <Li>If you don't, please send a reading on your moving day.</Li>
            <Li>If we don't have a reading, we'll estimate your bill.</Li>
            <Li>
              If you need to submit a reading after your moving day, please
              contact us.
            </Li>
          </Ul>
          <AnalyticsClick
            name={MOVE_OUT_CONFIRM_METER_READ_SUBMIT}
            properties={{
              date,
            }}
          >
            <CTAButton
              onClick={() => {
                window.open(ROUTE_METER_READINGS, '_blank');
              }}
            >
              Send meter reading
            </CTAButton>
          </AnalyticsClick>
        </Step>
        <Step iconText="2">
          <div className={styles.listTitle}>Cancel your other OVO services</div>
          <div>
            Be sure to end your contract for other OVO services, like Boiler
            Cover, that are linked to your old home.
          </div>
        </Step>
        <Step iconText="3">
          <div className={styles.listTitle}>Your final bill</div>
          <div>
            We'll send your final bill within six weeks of your moving out.
            Please don't cancel your Direct Debit, as we'll use it to pay your
            balance, then we'll cancel it for you.
          </div>
        </Step>
      </Stack>
    </Card>
  );
};
